import React, { useCallback, useEffect, useState } from 'react'
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import { Input } from 'reactstrap'
import UserDucks from 'stores/ducks/User.duck';

import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from 'reactstrap';

// import Error from 'components/alerts/Error';
import { NumberInput } from 'components/common/form/modules/input/Number';
import { Text } from 'components/common/form/modules/input/Text';
import { TextArea } from 'components/common/form/modules/input/TextArea';

import { Info } from 'components/common/form/modules/Info';
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { deleteInventory, isPaymentSetup, updateInventoryItem } from 'components/graphql/queries'
import { closeModal } from 'components/modal/modules/dispatcher/methods';

import { ResponsiveScatterPlot } from '@nivo/scatterplot'

import { updateSharedInventorybyInventoryId } from 'components/graphql/queries'
import PropTypes from 'prop-types';

// import Slider from '@material-ui/core/Slider';
import Tooltip from '@material-ui/core/Tooltip';

const ValueLabelComponent = (props) => {
    const { children, open, value } = props;
    return (
        <Tooltip open={open} enterTouchDelay={0} placement="right" title={value}>
            {children}
        </Tooltip>
    );
}

ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.number.isRequired,
};


const UpdateInventoryModal: React.FC<{ [label: string]: any }> = (props: any) => {

    if (props.user.id === '') {
        return null;
    }

    const today = new Date()
    const now = new Date()
    const zero = new Date()

    now.setHours(23)
    now.setMinutes(45)
    zero.setHours(0);
    zero.setMinutes(0);

    let flag1 = false;
    let flag2 = false;

    const [campaignId] = useState(props.campaignId)

    const [name, setName] = useState(props.name)
    const [price, setPrice] = useState(Number((props.price / 100).toFixed(2)))
    const [basePrice] = useState(0)
    const [quantity, setQuantity] = useState(props.quantity)
    const [description, setDescription] = useState(props.description)
    const [autoSale, setAutoSell] = useState(props.autoSale)

    const [height] = useState(props.floorplan ? props.floorplan.height : 10)
    const [width] = useState(props.floorplan ? props.floorplan.width : 10)
    const [labels] = useState(props.floorplan ? props.floorplan.labels : [])
    const [inventoryMap, setInventoryMap] = useState(props.floorplan ? props.floorplan.inventoryMap : [])
    const [data, setData] = useState([])

    const [btnDisabled, setBtnDisabled] = React.useState(false)
    const [updateBtnText, setUpateBtnText] = React.useState('UPDATE')

    const [sellAfter, setSellAfter] = useState(props.sellAfter ? props.sellAfter : '')
    let sellAfterName = ''
    if (props.sellAfter) {
        const item = props.inventory.find(i => {
            return i.id.toString().trim() === props.sellAfter.toString().trim()
        })
        if (item) {
            sellAfterName = item.name
        }
    }
    const [selectedName, setSelectedName] = useState(sellAfterName)

    const [hasOwnerSetupPayments, setHasOwnerSetupPayments] = useState(false)

    let canDelete = true;
    // If inventory is bought, can't delete it
    if (props.bought !== 0) {
        canDelete = false;
    }
    inventoryMap.map((item: any) => {
        if (item.inventoryItemId.toString().trim() === props.id.toString().trim()) {
            // If inventory map has bids, can't delete it
            if (item.bid && item.bid.numBids > 0) {
                canDelete = false;
            }
        }
    })

    const [imageHeight, setImageHeight] = useState(0)

    const onImgLoad = useCallback(({ target: img }) => {
        setImageHeight(img.offsetHeight)
    }, [setImageHeight])

    const filteredInventoryMap = props.floorplan ? props.floorplan.inventoryMap.filter((item: any) => {
        return item.inventoryItemId.toString().trim() === props.id.toString().trim()
    }) : []

    let upForBidding = false;
    if (filteredInventoryMap.length > 0) {
        upForBidding = filteredInventoryMap[0].bid ? true : false
    }

    let bidPlaced = false;
    filteredInventoryMap.map((item) => {
        if (item.bid && item.bid.numBids > 0) {
            bidPlaced = true
        }
    })

    const [bid, setBid] = useState(upForBidding)
    const initSpots: any[] = []
    filteredInventoryMap.map((item: any) => {
        initSpots.push({
            x: item.x, y: item.y, bought: item.bought, buyerName: item.buyerName
        })
    })
    const [spots, setSpots] = useState(initSpots)

    const [assignSpot, setAssignSpot] = useState(filteredInventoryMap.length > 0 ? true : false)

    const [startTime, setStartTime] = useState(
        new Date(
            props.startTime.year,
            props.startTime.month - 1,
            props.startTime.day,
            (props.startTime.PM ? props.startTime.hour + 12 : props.startTime.hour),
            props.startTime.minute
        )
    )
    const [endTime, setEndTime] = useState(
        new Date(
            props.endTime.year,
            props.endTime.month - 1,
            props.endTime.day,
            (props.endTime.PM ? props.endTime.hour + 12 : props.endTime.hour),
            props.endTime.minute
        )
    )

    const handleStartChange = useCallback((e) => {
        if (e > endTime) {
            setStartTime(e)
            setEndTime(e)
        } else {
            if (bid) {
                const sevenDaysStart = new Date(endTime.getTime())
                sevenDaysStart.setDate((sevenDaysStart.getDate() - 7))

                const updatedEndTime = new Date(e.getTime())
                updatedEndTime.setDate(updatedEndTime.getDate() + 7)

                if (e > sevenDaysStart) {
                    setStartTime(e)
                } else {
                    setStartTime(e)
                    setEndTime(updatedEndTime)
                }
            } else {
                setStartTime(e)
            }
        }
    }, [endTime, setStartTime, setEndTime, bid])

    const handleEndChange = useCallback((e) => {
        if (e < startTime) {
            setStartTime(e)
            setEndTime(e)
        } else {

            if (bid) {
                const sevenDaysEnd = new Date(startTime.getTime())
                sevenDaysEnd.setDate((sevenDaysEnd.getDate() + 7))

                const updatedStartDate = new Date(e.getTime())
                updatedStartDate.setDate(updatedStartDate.getDate() - 7)

                if (e < sevenDaysEnd) {
                    setEndTime(e)
                } else {
                    setEndTime(e)
                    setStartTime(updatedStartDate)
                }
            } else {
                setEndTime(e)
            }
        }
    }, [startTime, setStartTime, setEndTime, bid])

    if (startTime.getFullYear() === today.getFullYear()) {
        if (startTime.getMonth() === today.getMonth()) {
            if (startTime.getDate() === today.getDate()) {
                flag1 = true;
            }
        }
    }
    if (endTime.getFullYear() === today.getFullYear()) {
        if (endTime.getMonth() === today.getMonth()) {
            if (endTime.getDate() === today.getDate()) {
                flag2 = true;
            }
        }
    }

    // Shared with
    const [sharedInventory, setSharedInventory] = useState(props.sharedInventory)

    const handleInventoryChange = useCallback((index, type, value) => {

        if (Number.isNaN(Number(value))) {
            return;
        }

        const temp = JSON.parse(JSON.stringify(sharedInventory))

        if (type === 'quantity') {
            temp[index].quantity = Number(value);
        } else if (type === 'commission') {
            temp[index].commission = Number(value);
        }
        setSharedInventory(temp)
    }, [sharedInventory, setSharedInventory])

    // const valuetext = (value) => {
    //     return `$${value}`;
    // }

    useEffect(() => {

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: isPaymentSetup,
                variables: {
                    id: props.createdBy
                }
            })
            .then(res => {
                if (res.data.data.user.isPaymentSetup === true) {
                    setHasOwnerSetupPayments(true)
                }
            })

        if (props.floorplan) {
            const initData: any = [];
            initData.push({
                id: 'Available',
                data: []
            })
            for (let m = 0; m < width; m++) {
                for (let n = 0; n < height; n++) {
                    const node1 = labels.find((item: any) => {
                        return item.x === m && item.y === n
                    })
                    const node2 = inventoryMap.find((item: any) => {
                        return item.x === m && item.y === n && item.inventoryItemId.toString().trim() === props.id.toString().trim()
                    })
                    if (node1 === undefined && node2 === undefined) {
                        initData[0].data.push({
                            x: m, y: n
                        })
                    }
                }
            }
            labels.map((item: any) => {
                initData.push({
                    id: item.label,
                    data: [{ x: item.x, y: item.y }]
                })
            })
            const allocatedInventory: any[] = [];
            inventoryMap.map((item: any) => {
                if (item.inventoryItemId.toString().trim() !== props.id.toString().trim()) {
                    allocatedInventory.push({ x: item.x, y: item.y })
                }
            })
            initData.push({
                id: 'Unavailable',
                data: allocatedInventory
            })
            if (assignSpot) {
                initData.push({
                    id: name,
                    data: spots
                })
            }
            setData(initData)
        }
    }, [setData, height, width, labels, spots, assignSpot, name, inventoryMap, props.id, setHasOwnerSetupPayments])

    const isAdminOrOwner = props.user.isAdmin || props.createdBy === props.user.id

    const nodeOnClick = useCallback((n, e) => {

        const label = labels.find((item: any) => {
            return item.x === n.data.x && item.y === n.data.y
        })
        const mapItem = inventoryMap.findIndex((item: any) => {
            return item.x === n.data.x && item.y === n.data.y
        })
        const index = spots.findIndex((item: any) => {
            return item.x === n.data.x && item.y === n.data.y
        });

        if (mapItem !== -1) {
            if (inventoryMap[mapItem].bid && inventoryMap[mapItem].bid.numBids > 0) {
                alert('Bids have been placed on chosen spot')
                return;
            }
        }

        if (index === -1) {
            if (!label && mapItem === -1) {
                const updatedSpots = JSON.parse(JSON.stringify(spots))
                updatedSpots.push({
                    x: n.data.x, y: n.data.y, bought: false, buyerName: null
                })
                setSpots(updatedSpots)
                setQuantity(updatedSpots.length)
                const updatedInventoryMap = JSON.parse(JSON.stringify(inventoryMap))
                updatedInventoryMap.push({
                    x: n.data.x, y: n.data.y, bought: false, buyerName: null, inventoryItemId: props.id
                })
                setInventoryMap(updatedInventoryMap)
            }
        } else {
            if (!inventoryMap[mapItem].bought) {
                const updatedSpots = JSON.parse(JSON.stringify(spots))
                updatedSpots.splice(index, 1)
                setSpots(updatedSpots)
                setQuantity(updatedSpots.length)
                // Remove from inventory map
                const updatedInventoryMap = JSON.parse(JSON.stringify(inventoryMap))
                updatedInventoryMap.splice(mapItem, 1)
                setInventoryMap(updatedInventoryMap)
            } else {
                alert('Table already purchased')
                return;
            }

        }

    }, [spots, setSpots, labels, inventoryMap, setInventoryMap, setQuantity, props.id])

    const handleDelete = useCallback(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: deleteInventory,
                variables: {
                    id: props.id,
                    campaignId
                }
            })
            .then(res => {
                if (res.data.data.inventoryItem.delete) {
                    props.reloadData();
                    closeModal()
                } else {
                    alert('Unknown error occurred, try again')
                }
            })
            .catch(err => {
                console.log(err)
            })
    }, [props.id, props.reloadData, campaignId])

    const resetUpdateBtn = () => {
        setBtnDisabled(false)
        setUpateBtnText('UPDATE')
    }

    const handleCreateInventory = useCallback(() => {

        if (name.trim() === '') {
            alert('Name is required')
            resetUpdateBtn()
            return;
        }

        if (Number(price) < 0) {
            alert('Price is invalid')
            resetUpdateBtn()
            return;
        }

        if (Number.isNaN(Number(price))) {
            alert('Price should be a number. No alphabets/symbols. (Decimal allowed.) ');
            resetUpdateBtn()
            return;
        }

        if (Number.isNaN(Number(quantity)) || (Number(quantity) % 1 !== 0)) {
            alert('Quantity should be a whole number.');
            resetUpdateBtn()
            return;
        }

        if (bid) {
            if (Number(price) < 1) {
                alert('Minimum bid amount is $1')
                resetUpdateBtn()
                return;
            }
        }

        if (Number(quantity) < 0) {
            alert('Quantity is invalid')
            resetUpdateBtn()
            return;
        }

        if (Number(quantity) < Number(props.bought)) {
            alert('Quantity is lesser than minimum')
            resetUpdateBtn()
            return;
        }

        const oldPrice = Number((props.price / 100).toFixed(2))
        if (Number(price) < oldPrice) {
            alert('New price must be greater than or equal to previous price.')
            resetUpdateBtn()
            return;
        }

        const bidStartDate = new Date(
            endTime.getFullYear(),
            endTime.getMonth(),
            endTime.getDate(),
            endTime.getHours(),
            endTime.getMinutes()
        )
        bidStartDate.setDate(bidStartDate.getDate() - 7)

        const inventoryItem = {
            name,
            price: Number(price),
            quantity: Number(quantity),
            description,
            autoSale,
            campaignId,
            startTime: bid || autoSale ? {
                year: startTime.getFullYear(),
                month: startTime.getMonth() + 1,
                day: startTime.getDate(),
                hour: startTime.getHours() > 12 ? startTime.getHours() - 12 : startTime.getHours(),
                minute: startTime.getMinutes(),
                PM: startTime.getHours() > 12 ? true : false
            } : null,
            endTime: bid || autoSale ? {
                year: endTime.getFullYear(),
                month: endTime.getMonth() + 1,
                day: endTime.getDate(),
                hour: endTime.getHours() > 12 ? endTime.getHours() - 12 : endTime.getHours(),
                minute: endTime.getMinutes(),
                PM: endTime.getHours() > 12 ? true : false
            } : null,
            spots: assignSpot ? spots : [],
            sellAfter: sellAfter === '' ? null : sellAfter
        }

        setBtnDisabled(true)
        setUpateBtnText('UPDATING...')

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: updateInventoryItem,
                variables: {
                    inventoryItem,
                    sellerId: props.user.isAdmin ? props.createdBy : props.user.id,
                    inventoryItemId: props.id,
                    bid
                }
            })
            .then(res => {
                console.log(res)
                if (res.data.data.inventoryItem.update) {
                    props.reloadData();
                    closeModal();
                } else {
                    alert('Unknown error occurred, try again')
                    resetUpdateBtn()
                }
            })
            .catch(err => {
                console.log(err)
                resetUpdateBtn()
            })
    }, [campaignId, name, price, quantity,
        description, basePrice, props.user, props.createdBy,
        spots, assignSpot, sellAfter, props.price,
        autoSale, startTime, endTime, props.id, bid])

    const updateCommission = useCallback(() => {

        let qtyErr = false
        let comErr = false

        sharedInventory.map((item: any, index: number) => {

            if (Number(item.quantity) < Number(item.minQuantity)
                || Number(item.quantity) > Number(item.maxQuantity)) {
                qtyErr = true
            }

            if (Number(item.commission) < Number(props.sharedInventory[index].commission)
                || Number(item.commission) > Number(item.maxCommission)) {
                comErr = true
            }

        })

        if (qtyErr) {
            alert('Quantity is invalid for one or more items')
            resetUpdateBtn()
            return
        }

        setBtnDisabled(true)
        setUpateBtnText('UPDATING...')

        if (comErr) {
            alert('Commission is invalid for one or more items')
            return
        }

        setBtnDisabled(true)
        setUpateBtnText('UPDATING...')

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: updateSharedInventorybyInventoryId,
                variables: {
                    campaignId: props.campaignId,
                    userId: props.user.isAdmin ? props.createdBy : props.user.id,
                    inventoryItemId: props.inventoryItemId,
                    inventoryItems: sharedInventory.map((i: any) => {
                        return {
                            username: i.username,
                            quantity: Number(i.quantity),
                            commission: Number(i.commission) * 100,
                        }
                    })
                }
            })
            .then(res => {
                if (res.data.data.inventoryItem.updateSharedInventorybyInventoryId) {
                    if(isAdminOrOwner) {
                        handleCreateInventory()
                    } else {
                        props.reloadData();
                        closeModal();
                    } 
                } else {
                    alert('An unknown error occurred, try again')
                    resetUpdateBtn()
                }
            })
            .catch(err => {
                console.log(err)
                alert('An unknown error occurred, try again')
                resetUpdateBtn()
            })

    }, [sharedInventory, props.sharedInventory, props.inventoryItemId, props.user, props.campaignId, handleCreateInventory])

    const CustomNode = useCallback(({
        node,
        x,
        y,
        size,
        color,
        blendMode,
        onMouseEnter,
        onMouseMove,
        onMouseLeave,
        onClick,
    }) => {
        const label = props.floorplan ? props.floorplan.labels.find((i: any) => {
            return i.label.toString().trim() === node.data.serieId.toString().trim()
        }) : null
        if (!label) {
            return (
                <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                    <circle
                        stroke={node.data.serieId === 'Available' ? "#242d51" : '#f1f1f1'}
                        stroke-width="0.5"
                        fill-opacity={node.data.serieId === 'Available' || node.data.serieId === 'Unavailable' ? 0.4 : 1}
                        stroke-opacity={0.75}
                        r={size * 0.5}
                        fill={node.data.serieId === 'Available' ? '#f1f1f1' :
                            node.data.serieId === 'Unavailable' ? '#242d51' : '#d63191'}
                        style={{ mixBlendMode: blendMode, zIndex: 15000000, opacity: 1 }}
                        onMouseEnter={onMouseEnter}
                        onMouseMove={onMouseMove}
                        onMouseLeave={onMouseLeave}
                        onClick={onClick}
                    />
                </g>
            )
        }
        return (
            <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                <text
                    x={size * -1}
                    y={size * 0.5}
                    font-size='8px'
                    font-style='bold'
                    color='#1931b9'
                    font-color='#1931b9'
                    style={{ zIndex: 150, opacity: 1 }}
                >
                    {label.label.toUpperCase()}
                </text>
            </g>
        )
    }, [props.floorplan])

    

    return <div style={{ paddingTop: isAdminOrOwner ? '20px' : '0px', paddingBottom: '20px' }}>
        { 
            isAdminOrOwner ? <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                <div style={{ marginBottom: 4 }}>
                    <Text
                        label='Name'
                        value={name}
                        onChange={e => setName(e.target.value)}
                        required={true}
                    />
                </div>
                <div style={{ marginBottom: 4 }}>
                    <TextArea
                        label='Description'
                        value={description}
                        onChange={e => {
                            if (e.target.value.length > 200) {
                                setDescription(e.target.value.substring(0, 200))
                            } else {
                                setDescription(e.target.value)
                            }
                        }}
                        placeholder={'(Optional)'}
                        infoMessage={((200 - description.length).toString() + ' characters left')}
                    />
                </div>
                {
                    assignSpot ? null :
                        <NumberInput
                            label='Qty'
                            value={quantity}
                            onChange={e => setQuantity(e.target.value)}
                            required={true}
                            infoMessage={'Min. ' + props.bought.toString()}
                        />
                }
                <div>
                    {
                        hasOwnerSetupPayments ?
                            <div style={{ marginTop: 4 }}>
                                <NumberInput
                                    label={bid ? 'Bid Minimum' : 'Price'}
                                    value={price}
                                    onChange={e => setPrice(e.target.value)}
                                    required={true}
                                />
                                <Info>
                                    min ${(props.price / 100).toFixed(2)}. Enter numeric value.
                                </Info>
                            </div> : <div>
                                <h6>
                                    Price $0
                                </h6>
                                <p style={{ fontSize: '10px' }}>
                                    Campaign owner has not set up payments yet.
                                </p>
                            </div>
                    }
                </div>
                {
                    !bid ?
                        <div style={{ paddingLeft: '20px', width: '100%', textAlign: 'left' }}>
                            <br />
                            <Input
                                type="checkbox"
                                checked={autoSale}
                                onChange={e => setAutoSell(!autoSale)}
                                style={{ height: 'auto' }}
                            />
                            <span style={{ paddingLeft: '5px' }}>
                                Customise Sales Time
                            </span>
                        </div>
                        : null
                }
                {
                    (autoSale || bid) && !bidPlaced ?
                        <div style={{ textAlign: 'left', paddingTop: '20px' }}>
                            <div style={{ width: '100%' }}>
                                <p>Start</p>
                                <DatePicker
                                    selected={startTime}
                                    onChange={handleStartChange}
                                    selectsStart={true}
                                    startDate={startTime}
                                    endDate={endTime}
                                    minDate={new Date()}
                                    minTime={flag1 ? new Date() : zero}
                                    maxTime={now}

                                    showTimeSelect={true}
                                    timeFormat="HH:mm"
                                    timeIntervals={15}
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    timeCaption="time"
                                    style={{ width: '100%', border: 'none', backgroundColor: '#ebecf1' }}

                                />
                            </div>
                            <p />
                            <div style={{ width: '100%' }}>
                                <p>End</p>
                                <DatePicker
                                    selected={endTime}
                                    onChange={handleEndChange}
                                    selectsEnd={true}
                                    startDate={startTime}
                                    endDate={endTime}
                                    minDate={startTime}

                                    minTime={flag2 ? new Date() : zero}
                                    maxTime={now}

                                    showTimeSelect={true}
                                    timeFormat="HH:mm"
                                    timeIntervals={15}
                                    dateFormat="MMMM d, yyyy h:mm aa"
                                    timeCaption="time"
                                    style={{ width: '100%', border: 'none', backgroundColor: '#ebecf1' }}
                                />
                            </div>
                        </div>
                        : null
                }
                {
                    props.floorplan && props.bought === 0 ?
                        <div style={{ paddingLeft: '20px', width: '100%', textAlign: 'left' }}>
                            <br />
                            <Input
                                type="checkbox"
                                checked={assignSpot}
                                onChange={e => {
                                    if (assignSpot) {
                                        setBid(false)
                                    }
                                    setAssignSpot(!assignSpot)
                                    setQuantity(spots.length)
                                }}
                                style={{ height: 'auto' }}
                                disabled={bidPlaced}
                            />
                            <span style={{ paddingLeft: '5px' }}>
                                Map to Seating Layout
                            </span>
                        </div> : null
                }
                {
                    props.floorplan && assignSpot && props.bought === 0 ?
                        <div style={{ paddingLeft: '20px', width: '100%', textAlign: 'left' }}>
                            <br />
                            <Input
                                type="checkbox"
                                checked={bid}
                                onChange={e => {
                                    if (!bid) {
                                        const updatedEndTime = new Date(startTime.getTime())
                                        updatedEndTime.setDate(updatedEndTime.getDate() + 7)
                                        setEndTime(updatedEndTime)
                                    }
                                    setBid(!bid)
                                }}
                                style={{ height: 'auto' }}
                                disabled={!hasOwnerSetupPayments || bidPlaced}
                            />
                            <span style={{ paddingLeft: '5px' }}>
                                Bidding
                            </span>
                        </div> : null
                }
                {
                    props.floorplan && assignSpot && props.bought === 0 ?
                        <Info style={{ paddingLeft: '20px' }}>
                            Maximum bid period duration is 7 days. You cannot modify this period once a bid is placed.
                        </Info> : null
                }
                {
                    props.floorplan && assignSpot ?
                        <div style={{ position: 'relative', marginTop: '10px', marginBottom: props.fpBackground ? imageHeight + 25 : height * 26 }}>
                            <div style={{ position: 'absolute' }}>
                                {
                                    props.fpBackground ?
                                        <img src={props.fpBackground}
                                            onLoad={e => onImgLoad(e)}
                                            style={{ width: '100%', opacity: 0.75, zIndex: 30, borderRadius: '10px' }} /> : null
                                }
                            </div>
                            <div style={{ position: 'absolute', height: props.fpBackground ? imageHeight : height * 25, width: '100%', opacity: 1, zIndex: 35 }}>
                                <ResponsiveScatterPlot
                                    data={data}
                                    margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                                    enableGridX={false}
                                    enableGridY={false}
                                    // blendMode="darken"
                                    axisTop={null}
                                    axisRight={null}
                                    axisLeft={null}
                                    axisBottom={null}
                                    onClick={(n, e) => nodeOnClick(n, e)}
                                    colors={{ scheme: 'paired' }}
                                    renderNode={CustomNode}
                                    tooltip={({ node }: any) => (
                                        <div
                                            className='blur-safari'
                                            style={{
                                                padding: '10px',
                                                color: '#242d51',
                                                borderRadius: '15px',
                                                backdropFilter: 'blur(20px)',
                                                border: '0.4px solid #f1f1f1',
                                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.02), 0 1px 3px rgba(0, 0, 0, 0.02)'
                                            }}
                                        >
                                            <strong>
                                                {node.data.serieId}
                                            </strong>
                                        </div>
                                    )}
                                />
                            </div>
                        </div> : null
                }
            {
                props.inventory.length > 0 ?
                    <div>
                        <br />
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <p className='sexyBlack'>
                                Start Selling After
                                <br />
                            </p>
                            <UncontrolledDropdown style={{ float: 'left', paddingLeft: '10px' }}>
                                <DropdownToggle
                                    caret={true}
                                    className='new-button-cancel'
                                    data-toggle="dropdown"
                                    tag='button'
                                >
                                    {sellAfter === '' ? '-' : selectedName}
                                </DropdownToggle>
                                <DropdownMenu style={{ borderRadius: '10px' }}>
                                    <DropdownItem onClick={() => setSellAfter('')}>
                                        -
                                    </DropdownItem>
                                    {
                                        props.inventory.map((item) => {
                                            if (
                                                item.id.toString().trim() !== props.id.toString().trim() &&
                                                (!item.sellAfter || item.sellAfter.toString().trim() !== props.id.toString().trim())
                                            ) {
                                                return <DropdownItem onClick={() => {
                                                    setSellAfter(item.id)
                                                    setSelectedName(item.name)
                                                }} key={item.id}>
                                                    {item.name}{' $' + (item.price / 100).toFixed(2)}
                                                </DropdownItem>
                                            }
                                        })
                                    }
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </div> : null
            }
                {/* {
                error ?
                    <div style={{ padding: '20px' }}>
                        <Error content={errorMessage} />
                    </div>
                    : null
            } */}
            </div> : null 
        }

        {/* Shared With */}
        <div style={{ marginTop: isAdminOrOwner ? 30 : 0 }}>
            <h6 style={{ paddingLeft: '20px' }}>
                Shared With
            </h6>
            <div style={{ overflowX: "scroll", paddingTop: '10px' }}>
                {
                    sharedInventory.length > 0 ?
                        <table className='table-responsive--base m-0' style={{ width: '100%', textAlign: 'left', fontSize: '12px', paddingTop: '0px', marginTop: '5px' }}>
                            <thead>
                                <tr>
                                    <td>USERNAME</td>
                                    <td>QTY</td>
                                    <td>COMMISSION</td>
                                    <td>SALES</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    sharedInventory.map((item: any, index: any) => {
                                        return <tr key={index} style={{ alignContent: 'center', height: 'auto', padding: '10px' }}>
                                            <td>
                                                {
                                                    item.username.includes("-additional-link-") ?
                                                        (item.username.split("-")[0] + " (link #" + (Number(item.username.split("-")[3]) + 2).toString() + ")") : item.username
                                                }
                                            </td>
                                            <td>
                                                <NumberInput
                                                    value={item.quantity}
                                                    min={item.minQuantity}
                                                    max={item.maxQuantity}
                                                    onChange={(e) => handleInventoryChange(index, 'quantity', e.target.value)}
                                                    infoMessage={item.minQuantity + ' - ' + item.maxQuantity}
                                                />
                                            </td>
                                            {
                                                !item.username.includes("-additional-link-") ?
                                                    <td>
                                                        <NumberInput
                                                            value={item.commission}
                                                            min={props.sharedInventory[index].commission}
                                                            max={item.maxCommission}
                                                            onChange={e => handleInventoryChange(index, 'commission', e.target.value)}
                                                            required={true}
                                                        />
                                                        {/* <Slider
                                                            value={item.commission}
                                                            onChange={(d, e) => handleInventoryChange(index, 'commission', Number(e))}
                                                            min={props.sharedInventory[index].commission}
                                                            max={item.maxCommission}
                                                            valueLabelDisplay="auto"
                                                            aria-labelledby="continuous-slider"
                                                            valueLabelFormat={valuetext}
                                                            style={{ fontSize: '8px' }}
                                                            ValueLabelComponent={ValueLabelComponent}
                                                        /> */}
                                                        <Info>
                                                            Affiliate earns  ${item.commission.toFixed(2)} <br />
                                                            You earn  ${
                                                                isAdminOrOwner 
                                                                    ? (item.inventoryItemPrice - item.commission).toFixed(2)
                                                                    : (item.maxCommission - item.commission).toFixed(2)
                                                            }<br />
                                                            (Minimum. ${props.sharedInventory[index].commission})
                                                        </Info>
                                                    </td>
                                                    : <td>
                                                        -
                                                    </td>}
                                            <td>
                                                {item.minQuantity}
                                            </td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                        :
                        <p style={{ width: '100%', textAlign: 'center' }}>
                            Inventory item not shared with affiliates
                        </p>
                }
            </div>
            {/* {
                error ?
                    <div style={{ padding: '20px' }}>
                        <Error content={errorMessage} />
                    </div>
                    : null
            } */}

            {/* <div style={{ width: '100%', textAlign: 'center', paddingTop: '25px' }}>
                <button
                    className="new-button-save"
                    onClick={e => handleCreateInventory()}
                >
                    UPDATE
                </button>
            </div> */}
            {/* <div style={{ width: '100%', textAlign: 'center', paddingTop: '10px' }}>
                <button className='new-button-cancel' onClick={() => closeModal()}>
                    CANCEL
                </button>
            </div>  */}
        </div>
        <div style={{ width: '100%', textAlign: 'center', paddingTop: '20px' }}>
            <button
                disabled={btnDisabled}
                role="submit"
                type="submit"
                className="new-button-save"
                onClick={e => updateCommission()}
            >
                {updateBtnText}
            </button>
        </div>
        {
            canDelete && isAdminOrOwner ? <div style={{ width: '100%', textAlign: 'center', paddingTop: '17px' }}>
                <button
                    className="new-button-blue-outline"
                    onClick={e => handleDelete()}
                >
                    DELETE
                </button>
            </div> : null
        }
        <div style={{ width: '100%', textAlign: 'center', paddingTop: '17px' }}>
            <button className='new-button-cancel' onClick={() => closeModal()}>
                CANCEL
            </button>
        </div>
    </div >
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(UpdateInventoryModal);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/UpdateInventory.modal.tsx